package nl.astraeus.midi.audio

import nl.astraeus.midi.audio.AudioContextHandler.audioContext
import nl.astraeus.midi.message.TimedMidiMessage
import org.w3c.dom.MessageEvent
import org.w3c.dom.MessagePort

enum class ModuleStatus {
  INIT,
  LOADING,
  READY
}

class AudioModule(
  val jsFile: String
) {
  var status = ModuleStatus.INIT
  var module: dynamic = null

  fun load(action: () -> Unit = {}) {
    if (module == null && status == ModuleStatus.INIT) {
      status = ModuleStatus.LOADING

      module = audioContext.audioWorklet.addModule(
        jsFile
      )
      module.then {
        status = ModuleStatus.READY
        action()
      }
    } else if (status == ModuleStatus.READY) {
      action()
    } else {
      console.log("Module not yet loaded")
    }
  }
}

abstract class AudioNode(
  val jsFile: String,
  val processorName: String,
  val numberOfInputs: Int = 0,
  val outputChannelCount: Array<Int> = arrayOf(2),
  val destination: dynamic = null,
  val outputIndex: Int = 0,
  val inputIndex: Int = 0
) {
  val module = AudioModule(jsFile)
  var created = false
  var node: dynamic = null
  var port: MessagePort? = null

  abstract fun onMessage(message: MessageEvent)

  open fun postMessage(vararg data: Int) {
    if (port == null) {
      console.log("postMessage port is NULL!")
    }

    val array = ByteArray(data.size) { data[it].toByte() }

    port?.postMessage(
      TimedMidiMessage(
        audioContext.currentTime,
        *array
      ).data.buffer.toByteArray()
    )
  }

  open fun postMessage(msg: Any) {
    if (port == null) {
      console.log("postMessage port is NULL!")
    }
    port?.postMessage(msg)
    //console.log("Posted message", audioContext.currentTime)
  }

  // call from user gesture
  fun create(done: (node: dynamic) -> Unit) {
    module.load {
      node = AudioWorkletNode(
        audioContext,
        processorName,
        AudioWorkletNodeParameters(
          numberOfInputs,
          outputChannelCount
        )
      )

      if (destination == null) {
        node.connect(audioContext.destination)
      } else {
        node.connect(destination, outputIndex, inputIndex)
      }

      node.port.onmessage = ::onMessage

      port = node.port as? MessagePort

      created = true
      console.log("Created node: ${audioContext.currentTime}")

      done(node)
    }
  }
}
